/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Workspace dashboard widgets and the host that switches between them.
 * Pages that embed gridster / codemirror stay in their owning feature modules.
 */
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../common/app-shared.module';
import {LineItemLabelsModule} from '../line-item/line-item-labels.module';
import {WorkspaceWidgetModalComponent} from './workspace-widget-modal.component';
import {WorkspaceWidgetHostComponent} from './workspace-widget-host.component';
import {StatsWidgetComponent} from './widget/stats-widget.component';
import {BarChartWidgetComponent} from './widget/bar-chart-widget.component';
import {TreeMapWidgetComponent} from './widget/tree-map-widget.component';
import {LineItemListWidgetComponent} from './widget/line-item-list-widget.component';
import {LineItemListSummaryComponent} from './widget/line-item-list-summary.component';
import {OrderListWidgetComponent} from './widget/order-list-widget.component';
import {WorkspaceVelocitySlimComponent} from './widget/workspace-velocity-slim.component';
import {AdvertiserEarningsWidgetComponent} from './widget/advertiser-earnings-widget.component';
import {ExternalIframeWidgetComponent} from './widget/external-iframe-widget.component';
import {HtmlInsertionWidgetComponent} from './widget/html-insertion-widget.component';

const WORKSPACE_WIDGETS = [
  WorkspaceWidgetModalComponent,
  WorkspaceWidgetHostComponent,
  StatsWidgetComponent,
  BarChartWidgetComponent,
  TreeMapWidgetComponent,
  LineItemListWidgetComponent,
  LineItemListSummaryComponent,
  OrderListWidgetComponent,
  WorkspaceVelocitySlimComponent,
  AdvertiserEarningsWidgetComponent,
  ExternalIframeWidgetComponent,
  HtmlInsertionWidgetComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    TranslateModule,
    UIRouterModule,
    LineItemLabelsModule
  ],
  declarations: WORKSPACE_WIDGETS,
  exports: WORKSPACE_WIDGETS
})
export class WorkspaceWidgetsModule {
}
